module.exports = "data:image/gif;base64,R0lGODlhBAAFAIAAAP///01JSiH5BAAAAAAALAAAAAAEAAUAAAIGRICWygcFADs="